<template>
  <div>
    <el-dialog
      class="dialogSearchNewContact"
      width="720px"
      title="Tìm kiếm liên hệ"
      :close-on-click-modal="false"
      :visible="true"
      @close="$emit('close')">
      <div
        slot="title"
        class="d-flex align-items-center justify-content-between pb-2 px-3 py-2 border-bottom"
        style="margin-top: -10px">
        <div class="d-flex align-items-center mt-2">
          <span
            class="font-16 fw-700"
            style="width: 90px">
            Thêm bạn
          </span>
          <div class="phone-input-wrapper d-flex align-items-center">
            <!-- PREFIX -->
            <el-dropdown
              trigger="click"
              @command="selectCountry"
            >
              <div class="phone-prefix d-flex align-items-center">
                <img
                  :src="`https://flagcdn.com/w20/${selectedCountry.code.toLowerCase()}.png`"
                  width="20"
                />
                <span class="ms-1">({{ selectedCountry.callingCode }})</span>
                <i class="el-icon-arrow-down ml-1"></i>
              </div>

              <el-dropdown-menu slot="dropdown" class="country-dropdown">
                <div class="country-search px-2 pb-2">
                  <el-input
                    v-model="countryKeyword"
                    size="mini"
                    clearable
                    placeholder="Tìm quốc gia..."
                  />
                </div>

                <el-dropdown-item
                  v-for="c in filteredCountries"
                  :key="c.code"
                  :command="c"
                >
                  <div class="d-flex align-items-center w-100 justify-content-between">
                    <div class="d-flex align-items-center">
                      <!-- <img
                        :src="`https://flagcdn.com/w20/${c.code.toLowerCase()}.png`"
                        width="20"
                        class="mr-2"
                      /> -->
                      <span>{{ c.name }}</span>
                    </div>

                    <span class="text-muted">{{ c.callingCode }}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- INPUT -->
            <el-input
              v-model="phoneNumber"
              ref="inputMesage"
              style="width: 196px"
              size="small"
              clearable
              placeholder="Nhập số điện thoại"
              @input="searchKeyChanged"
              @keydown.enter.exact.native="searchContact"
            />
          </div>
        </div>
        <el-select
          class="me-4 mt-2"
          @change="changeAccount"
          v-model="filter.selectAccountId"
          filterable
          default-first-option
          placeholder="Chọn tài khoản"
          size="small"
          style="max-width: 160px">
          <el-option
            v-for="account in accounts"
            :key="account.accountId"
            :label="getAccountName(account)"
            :value="account.accountId"></el-option>
        </el-select>
      </div>
      <div style="width: 720px">
        <div v-if="accounts.length > 0">
          <div class="d-flex">
            <div
              style="width: 300px"
              class="border-right pb-12">
              <div v-if="filter.profile.avatar">
                <div
                  class="d-flex"
                  style="height: 100px; position: relative">
                  <el-image
                    :src="filter.profile.cover"
                    fit="cover"
                    class="w-100" />
                  <div style="position: absolute; bottom: -26px; left: 0; right: 0; height: 56px">
                    <div class="d-flex justify-content-center">
                      <el-avatar
                        class="rounded-circle"
                        style="border: 2px solid white"
                        :src="filter.profile.avatar"
                        alt=""
                        :size="56" />
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-center" style="margin-top: 28px">
                  <div class="font-14 fw-700 me-2">
                    {{ filter.conversation.swName ? filter.conversation.swName : filter.conversation.toName }}
                  </div>
                  <div @click="showPopOverSwName=true">
                    <IconV2
                      class="pointer"
                      name="v2-edit" />
                  </div>
                </div>
                <div v-if="filter.showConversation">
                  <div v-if="disableInfo().show">
                    <div v-if="showInput">
                      <div
                        v-if="selectType == 'friend'"
                        class="mt-4 px-12">
                        <el-input
                          v-model="content"
                          type="textarea"
                          resize="none"
                          :rows="4"
                          placeholder="Nhập lời mời kết bạn"
                          :maxlength="150"
                          show-word-limit />
                      </div>
                      <div
                        v-if="selectType == 'message'"
                        class="mt-4 px-12">
                        <el-input
                          class="text-break"
                          v-model="content"
                          type="textarea"
                          resize="none"
                          :rows="4"
                          placeholder="Nhập nội dung tin nhắn" />
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-center mt-2 px-12"
                      v-else>
                      <el-button
                        class=""
                        style="width: 130px"
                        size="small"
                        type="danger"
                        @click="undoFriendRequest()"
                        :disabled="filter.profile.isBlocked !== null && filter.profile.isBlocked === 1"
                        plain
                        v-if="requestFriend.is_requested === 1">
                        Thu hồi
                      </el-button>
                      <el-button
                        v-else-if="filter.profile.isFr === 0"
                        class=""
                        type="primary"
                        size="small"
                        plain
                        :disabled="filter.profile.isBlocked !== null && filter.profile.isBlocked === 1"
                        @click="showAddFriend()"
                        style="width: 130px">
                        <span class="fw-500 font-14">Kết bạn</span>
                      </el-button>
                      <el-button
                        class=""
                        size="small"
                        type="primary"
                        style="width: 130px"
                        @click="showMessageInput()">
                        <span class="fw-500 font-14">Nhắn tin</span>
                      </el-button>
                    </div>
                    <div
                      v-if="showInput"
                      class="d-flex justify-content-end mt-1 px-12">
                      <el-button
                        size="small"
                        plain
                        type="info"
                        @click="showInput = false">
                        Hủy
                      </el-button>

                      <el-button
                        size="small"
                        type="primary"
                        @click="addFriend()"
                        v-if="selectType == 'friend'">
                        Kết bạn
                      </el-button>
                      <el-button
                        size="small"
                        type="primary"
                        @click="sendMessage()"
                        v-else>
                        Gửi
                      </el-button>
                    </div>
                    <div class="flex-column mt-2 py-2 border-top border-bottom px-12">
                      <div class="d-flex">
                        <div class="w-100px mx-1 text-secondary">Giới tính:</div>
                        <div class="flex-1">{{ filter.profile.gender === 0 ? "Nam" : "Nữ" }}</div>
                      </div>
                      <div class="d-flex mt-2">
                        <div class="w-100px mx-1 text-secondary">Ngày sinh:</div>
                        <div class="flex-1">{{ filter.profile.sdob }}</div>
                      </div>
                      <div class="d-flex mt-2">
                        <div class="w-100px mx-1 text-secondary">Số điện thoại:</div>
                        <div class="flex-1">{{ filter.profile.phoneNumber }}</div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center justify-content-evenly">
                      <div
                        v-if="isShowListFriend()"
                        class="d-flex flex-column align-items-center text-center py-12">
                        <div
                          @click="onShareContactCard"
                          class="z2-btn-status-off z2-btn-circle-large pointer">
                          <IconV2 name="v2-profile" />
                        </div>
                        <span class="mt-2 font-13 fw-400">Gửi danh thiếp</span>
                      </div>
                      <div class="d-flex flex-column align-items-center text-center py-12">
                        <div
                          @click="handleActionBlock()"
                          class="z2-btn-status-off z2-btn-circle-large pointer">
                          <img
                            src="/assets/icon/icon_red_block.svg"
                            width="16px" />
                        </div>
                        <span class="mt-2 font-13 fw-400">
                          {{ !filter.profile.isBlocked ? "Chặn tin nhắn" : "Bỏ chặn tin nhắn" }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="text-break d-flex text-danger"
                    v-else>
                    {{ disableInfo().message }}
                  </div>
                </div>
                <div
                  class="text-break d-flex text-danger" style="height: 209px !important;"
                  v-else>
                  Bạn không có quyền tương tác với liên hệ này!
                </div>
              </div>
              <div
                v-else
                class="d-flex align-items-center justify-content-center">
                <img src="/assets/icon/empty-search-contact.svg" />
              </div>
            </div>
            <div
              v-if="filter.showConversation"
              class="flex-1 py-2"
              style="width: 420px">
              <div class="d-flex flex-column px-12">
                <span class="font-size-14 fw-700 mb-2">Gắn thẻ nhanh</span>
                <el-input
                  placeholder="Tìm thẻ cần gắn"
                  v-model="searchTagName"
                  size="small">
                  <template slot="prepend">
                    <el-select
                      class="flex-1"
                      @change="changeTagOpt()"
                      v-model="selectTagOpt"
                      placeholder="Chọn tag"
                      size="small"
                      style="width: 140px">
                      <el-option
                        v-for="tag in tagOpt"
                        :key="tag.val"
                        :label="tag.key + ' (' + getTagCount(tag.val) + ') '"
                        :value="tag.val"></el-option>
                    </el-select>
                  </template>
                </el-input>
              </div>
              <div class="p-1 mt-2 bg-base-milk border-bottom border-top">
                <div
                  class="p-2 d-flex justify-content-start flex-wrap"
                  style="overflow-y: auto; max-height: 140px">
                  <div
                    v-for="item in listTagView"
                    :key="item.id"
                    @click="addOrRemoveTag(item)">
                    <TagV2
                      :data="item"
                      :inactive="!isSelected(item)"
                      :item="item"
                      :selected="isSelected(item)"
                      :is-button="true" />
                  </div>
                </div>
              </div>
              <div
                class="mt-2 px-12"
                v-if="filter.showConversation">
                <div class="d-flex justify-content-between">
                  <span class="font-size-14 fw-700">Thẻ đã gắn</span>
                  <span>{{ filter.conversation.tags.length }}</span>
                </div>
                <div
                  style="max-height: 90px; overflow-y: auto"
                  class="mt-2">
                  <div class="d-flex flex-wrap">
                    <div
                      v-for="item in filter.conversation.tags"
                      :key="item.id">
                      <TagCustom
                        v-if="false"
                        :item="item"
                        :selected="true"
                        :is-button="true" />
                      <TagV2
                        v-if="showTag(item.id)"
                        :data="item"
                        :inactive="false"
                        :item="item"
                        :selected="isSelected(item)"
                        :is-button="true" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="d-flex justify-content-center mt-4">
          Không có tài khoản nào được chọn
        </div>
      </div>
    </el-dialog>
    <el-dialog
      top="2vh"
      v-if="showMessageShare"
      title="Chia sẻ"
      width="520px"
      :visible.sync="showMessageShare"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <div style="z-index: 999">
        <SharePopupV2
          :shareContactCard="shareContactCard"
          :message="messageShare"
          :accountId="filter.selectAccountId"
          @closeSharePopup="showMessageShare = false"
          :message-list="[]" />
      </div>
    </el-dialog>

    <DialogBadWord
      v-if="replaceBadWord.show"
      :dataBadWord="replaceBadWord"
      :newMessage="content"
      :accountId="filter.conversation.accountId"
      @sendReplace="sendReplace"
      @close="closeReplaceBadWord" />
      <dialog-change-sw-name 
        v-if="showPopOverSwName"
        :showPopOverSwName="showPopOverSwName"
        :conversation="filter.conversation"
        @updated="onChangeSwName"
      />
  </div>
</template>

<script>
import TagCustom from "@/components/common/TagCustom";
import { HTTP } from "@/lib/http-common";
import TagV2 from "../TagV2.vue";
import { removeVietnameseTones } from "../../lib/text-utils";
import SharePopupV2 from "../message/SharePopupV2";
import DialogBadWord from "@/components/DialogBadWord";
import DialogChangeSwName from '../Popup/DialogChangeSwName.vue';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import countriesI18n from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countriesI18n.registerLocale(enLocale);

export default {
  name: "SearchNewContact",
  props: ["visidle"],
  components: { TagCustom, TagV2, SharePopupV2, DialogBadWord, DialogChangeSwName },
  data() {
    return {
      searchTagName: "",
      accounts: [],
      filter: this.newFilter(),
      tagOpt: [
        { key: "Tất cả tag", val: 0 },
        { key: "Tag chỉ định", val: 1 },
        { key: "Tag thường", val: 2 },
      ],
      selectTagOpt: 0,
      tags: [],
      tagView: [],
      requestFriend: {},
      selectType: "message",
      content: "",
      showInput: false,
      replaceBadWord: {
        show: false,
        items: [],
        content: "",
      },

      showMessageShare: false,
      messageShare: {},
      shareContactCard: {},

      showPopOverSwName: false,
      phoneNumber: "",
      countries: [],
      selectedCountry: {
        code: 'VN',
        name: 'Vietnam',
        callingCode: '+84',
      },
      countryKeyword: "",
    };
  },
  methods: {
    onChangeSwName() {
      this.showPopOverSwName = false
    },
    onShareContactCard() {
      this.shareContactCard = {
        accountId: this.filter.selectAccountId,
        friendId: this.filter.profile.userId,
      };
      this.showMessageShare = true;
    },
    getTagCount(valueOption) {
      switch (valueOption) {
        case 0: {
          return this.tags.length;
        }
        case 2: {
          return this.tags.filter((t) => !t.assign).length;
        }
        case 1: {
          return this.tags.filter((t) => t.assign).length;
        }
        default:
          return 0;
      }
    },
    handleActionBlock() {
      if (this.filter.profile.isBlocked === 1) this.actionUser("unblock");
      else this.actionUser("block");
    },
    actionUser(action) {
      let request = {
        accountId: this.filter.conversation.accountId,
        friendId: this.filter.conversation.toId,
        action: action,
        conversationId: this.filter.conversation.id,
      };
      this.$http.post("/api/message/block", request).then((resp) => {
        if (resp?.data?.error_message !== "Successful.") return this.alert("error", "Có lỗi xảy ra vui lòng thử lại");
        if (action === "block") {
          this.filter.profile.isBlocked = 1;
          this.alert("success", "Chặn thành công, người dùng này sẽ không thể gửi tin nhắn tới bạn");
        } else {
          this.filter.profile.isBlocked = 0;
          this.alert("success", "Bỏ chặn thành công");
        }
        this.$bus.$emit("handleBlock", { action: action, toId: this.filter.conversation.toId });
      });
    },
    showAddFriend() {
      this.content = "Xin chào " + this.filter.profile.displayName + ", kết bạn với mình nhé!";
      this.selectType = "friend";
      this.showInput = true;
    },
    addFriend() {
      this.$http
        .get("/api/contact/addFriend", {
          params: {
            msg: this.content,
            userId: this.filter.conversation.toId,
            accountId: this.filter.conversation.accountId,
          },
        })
        .then((resp) => {
          if (resp.data.error_code === 0) {
            let request = {
              accountId: this.filter.conversation.accountId,
              friendId: this.filter.conversation.toId,
            };
            this.$http.post("/api/conversation/friendRequestStatus", request).then((resp) => {
              let data = resp.data.data;
              if (data.is_requested === 1) {
                this.alert("success", "Gửi kết bạn thành công !");
              } else {
                this.alert("error", "Người dùng này đã từ chối trước đó");
              }
              this.showInput = false;
              this.requestFriend.is_requested = 1;
            });
          } else if (resp.data.error_code === 222) {
            this.$set(this.filter.profile, "isFr", 1);
          } else if (resp.data.error_code !== 0) {
            return this.alert("error", resp.data.error_message);
          }
        });
    },
    undoFriendRequest() {
      this.$http
        .get("/api/contact/undoFriendRequest", {
          params: {
            accountId: this.filter.conversation.accountId,
            userId: this.filter.conversation.toId,
          },
        })
        .then((resp) => {
          if (resp.data.error_code !== 0) {
            this.alertError(resp.data.error_message);
          }
        });
      this.alert("success", "Đã thu hồi lời mời kết bạn !");
      this.requestFriend.is_requested = 0;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr) {
          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.content;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    sendMessage() {
      if (!this.content) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }
      let items = this.filterCharacter(this.filter.conversation, this.content, this.filterCharacterArr);
      if (items.length > 0) {
        this.replaceBadWord.show = true;
        this.replaceBadWord.items = items;
        this.replaceBadWordContent();
      } else {
        this.sendMesV2();
      }
    },
    closeReplaceBadWord() {
      this.showInput = false;
      this.replaceBadWord.show = false;
    },
    sendMesV2(keys, replace) {
      let request = {
        accountId: this.filter.conversation.accountId,
        toId: this.filter.conversation.toId,
        message: this.content,
        conversationId: this.filter.conversation.id,
        bannedKeyword: keys ? keys : [],
        replace: replace,
      };
      this.content = "";
      this.$http.post("/api/message/sms", request);
      this.closeReplaceBadWord();
    },
    sendReplace({ newMessage, keys, replace }) {
      this.content = newMessage;
      this.sendMesV2(keys, replace);
    },
    disableInfo() {
      let resp = { show: true, message: "" };
      if (!this.isUserTypeAdmin()) {
        let count = this.filter.conversation.tags.filter((t) => t.assign && t.status == "ACTIVE");
        if (count != null && count.length > 0) {
          resp.show = false;
          resp.message = "Liên hệ này đã được gắn tag chỉ định, Bạn không có quyền tương tác với liên hệ này!";
          count.forEach((item) => {
            let it = this.app.tagAssignMe.filter((t) => t.id == item.id);
            if (it != null && it.length > 0) {
              resp.show = true;
            }
          });
        } else {
          if (this.app.showAllContact) {
            resp.show = true;
          } else {
            resp.show = false;
            resp.message = "Bạn cần gắn tag chỉ định trước khi tương tác với liên hệ này !";
          }
        }
      }
      return resp;
    },
    showMessageInput() {
      this.content = "";
      this.selectType = "message";
      this.showInput = true;
    },
    showTag(tagId) {
      let it = this.tags.filter((t) => t.id == tagId);
      if (it != null && it.length > 0) {
        return true;
      }
      return false;
    },
    getTagFilter() {},
    isSelected(item) {
      if (this.filter.conversation.id) {
        let it = this.filter.conversation.tags.filter((t) => t.id == item.id);
        if (it != null && it.length > 0) return true;
      }
      return false;
    },
    addOrRemoveTag(tag) {
      const index = this.filter.conversation.tags.findIndex((t) => {
        return t.id == tag.id;
      });
      if (index > -1) {
        this.filter.conversation.tags.splice(index, 1);
      } else {
        this.filter.conversation.tags.push(tag);
      }
      let request = {
        conversationId: this.filter.conversation.id,
        tagId: tag.id,
      };
      this.$http.post("/api/conversation/tag", request);
    },
    changeTagOpt() {
      if (this.selectTagOpt == 0) {
        this.tagView = this.tags;
      } else if (this.selectTagOpt == 1) {
        this.tagView = this.tags.filter((p) => p.assign);
      } else {
        this.tagView = this.tags.filter((p) => !p.assign);
      }
    },
    newFilter() {
      return {
        searchKey: "",
        selectAccountId: "",
        conversation: { id: "" },
        showConversation: false,
        profile: {},
      };
    },
    selectCountry(country) {
      this.selectedCountry = country;
      this.countryKeyword = '';
      this.updateSearchKey();
    },

    searchKeyChanged(val) {
      // chỉ cho nhập số
      this.phoneNumber = val.replace(/[^0-9]/g, '');
      this.updateSearchKey();

      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.searchContact();
      }, 700);
    },

    updateSearchKey() {
      if (!this.phoneNumber) {
        this.filter.searchKey = '';
        return;
      }

      if (this.phoneNumber.startsWith('0')) {
        this.filter.searchKey =
          this.selectedCountry.callingCode + this.phoneNumber.slice(1);
        return;
      }

      this.filter.searchKey =
        this.selectedCountry.callingCode + this.phoneNumber;
    },
    searchContact() {
      let searchKey = this.filter.searchKey;
      this.filter.showConversation = false;
      this.filter.conversation = { id: "" };
      this.filter.profile = {};
      if (searchKey.length < 9) return;
      if (searchKey.startsWith("0")) searchKey = "+84" + searchKey.substring(1);
      HTTP.post("/api/search/searchNewContact", {
          searchKey: searchKey,
          accountId: this.filter.selectAccountId
      }).then((res) => {
        if (res.data.profile) {
          this.filter.showConversation = res.data.showConversation;
          this.filter.conversation = res.data.conversation;
          this.filter.profile = res.data.profile;
          this.filter.conversation.toId = this.filter.profile.userId;
          this.filter.conversation.accountId = this.filter.selectAccountId;
          HTTP.post("/api/conversation/friendRequestStatus", {
            accountId: this.filter.conversation.accountId,
            friendId: this.filter.conversation.toId,
          }).then((resp) => {
            if (resp.data.error_code === 0) {
              this.requestFriend = resp.data.data;
            }
          });
        }
      });
    },
    changeAccount() {
      this.searchContact();
    },
    getTags() {
      HTTP.get("/api/tag").then((resp) => {
        this.tags = resp.data;
        this.changeTagOpt();
      });
    },
    async getAccounts() {
      // HTTP.get("/api/account").then((resp) => {
        // if (resp.status === "success") {
          this.accounts = await this.fetchAccountListWithZaloContact();
          this.filter.selectAccountId = this.accounts[0].accountId;
        // }
      // });
    },
  },
  computed: {
    filteredCountries() {
      const kw = this.countryKeyword.trim().toLowerCase();
      if (!kw) return this.countries;

      return this.countries.filter(c =>
        c.name.toLowerCase().includes(kw) ||
        c.callingCode.includes(kw)
      );
    },
    listTagView() {
      let view = [];
      switch (this.selectTagOpt) {
        case 0: {
          view = this.tags;
          break;
        }
        case 1: {
          view = this.tags.filter((p) => p.assign);
          break;
        }
        case 2: {
          view = this.tags.filter((p) => !p.assign);
          break;
        }
      }

      if (this.searchTagName) {
        view = view.filter(
          (tag) =>
            removeVietnameseTones(tag.name.toLowerCase()).includes(this.searchTagName.toLowerCase()) ||
            tag.name.toLowerCase().includes(this.searchTagName.toLowerCase())
        );
      }

      return view;
    },
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.filter.selectAccountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map((item) => [item[key], item])).values()];
      return unique;
    },
  },

  created() {
    this.getAccounts();
    this.getTags();

    this.filter = this.newFilter();
    const PRIORITY_CODES = ['VN', 'TW', 'KR', 'CN'];
    this.countries = getCountries()
      .map(code => {
        const name = countriesI18n.getName(code, 'en');

        if (!name) return null; // ❌ loại mấy thằng như +247

        return {
          code,
          name,
          callingCode: '+' + getCountryCallingCode(code),
        };
      })
      .filter(Boolean)
      .sort((a, b) => {
        const aPriority = PRIORITY_CODES.indexOf(a.code);
        const bPriority = PRIORITY_CODES.indexOf(b.code);

        if (aPriority !== -1 && bPriority !== -1) {
          return aPriority - bPriority;
        }

        if (aPriority !== -1) return -1;

        if (bPriority !== -1) return 1;

        return a.name.localeCompare(b.name);
      });
  },
};
</script>

<style lang="scss" >
.dialogSearchNewContact {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
}
</style>

<style scoped>
.country-dropdown {
  max-height: 300px;
  overflow-y: auto;
  padding-top: 4px;
}

.country-search .el-input__inner {
  height: 26px;
}

.phone-prefix {
  height: 32px;
  padding: 0 8px;
  border: 1px solid #dcdfe6;
  border-right: none;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
  background: #fff;
}

.phone-input-wrapper .el-input__inner {
  border-radius: 0 4px 4px 0;
}

</style>